export function prefersReducedMotion(): boolean {
  if (typeof window === "undefined") return true;
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

export function supportsWebGL(): boolean {
  if (typeof window === "undefined") return false;
  try {
    const canvas = document.createElement("canvas");
    return !!(canvas.getContext("webgl2") || canvas.getContext("webgl"));
  } catch {
    return false;
  }
}

export function isLowEndDevice(): boolean {
  if (typeof navigator === "undefined") return false;
  const cores = navigator.hardwareConcurrency ?? 4;
  const isSmallViewport = typeof window !== "undefined" && window.innerWidth < 640;
  return cores <= 2 || isSmallViewport;
}

export function canRender3D(): boolean {
  return supportsWebGL() && !prefersReducedMotion() && !isLowEndDevice();
}
